// extracted by mini-css-extract-plugin
module.exports = {"dateDottedLine":"FuH2fDdC"};